<template>
	<div>
		<!-- Filters -->
		<tenders-list-filters
			:options="options"
			:public-states-filter.sync="publicStatesFilter"
			:tender-states-filter.sync="tenderStatesFilter"
		/>

		<!-- Table Container Card -->
		<b-card
			no-body
			class="mb-0"
		>
			<div class="m-2">
				<!-- Table Top -->
				<b-row>
					<!-- Per Page -->
					<b-col
						cols="12"
						md="4"
						class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
					>
						<label>Mostrar</label>
						<v-select
							v-model="perPage"
							:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
							:options="perPageOptions"
							:clearable="false"
							class="per-page-selector d-inline-block mx-50"
						/>
						<label>registros</label>
					</b-col>

					<!-- Search -->
					<b-col
						cols="12"
						md="6"
						class="ml-auto"
					>
						<div class="d-flex">
							<b-form-input
								v-model="searchQuery"
								class="d-inline-block mr-1"
								placeholder="Buscar ..."
								trim
							/>
						</div>
					</b-col>
				</b-row>
			</div>

			<b-table
				ref="refTenderListTable"
				class="position-relative table-tenders"
				:style="totalTenders >= 1 && totalTenders <= 3 ? 'height: 280px' : 'height: inherit'"
				:items="fetchTenders"
				responsive
				:fields="tableColumns"
				primary-key="id2"
				:sort-by.sync="sortBy"
				show-empty
				empty-text="No se encontraron registros coincidentes"
				:sort-desc.sync="isSortDirDesc"
			>
				<template #table-busy>
					<div class="text-center text-primary my-2">
						<b-spinner class="align-middle mb-1"></b-spinner>
						<div>
							<b>CARGANDO</b>
						</div>
					</div>
				</template>

				<template #head(is_published)="data">
					<span v-html="data.label"></span>
				</template>

				<template #head(bidders_count)="data">
					<span v-html="data.label"></span>
				</template>

				<!-- 	<template #head(invitations_count)="data">
					<span v-html="data.label"></span>
				</template>-->

				<template #head(tender_state_name)="data">
					<span v-html="data.label"></span>
				</template>

				<template #head(published_at)="data">
					<span v-html="data.label"></span>
				</template>

				<template #cell(title)="data">
					<div style="width: 700px; text-transform: uppercase;">
						<b-media vertical-align="center">
							<b-link
								v-if="$can('manage','tenders')"
								:to="{ name: 'tenders-edit', params: { id: data.item.id } }"
								class="font-weight-bold d-block"
							>{{ data.item.title }}</b-link>
							<span
								v-else
								class="font-weight-bold d-block"
							>{{ data.item.title }}</span>
						</b-media>
					</div>
				</template>

				<template #cell(code)="data">
					<div class="text-nowrap">{{ data.item.code }}</div>
				</template>

				<template #cell(tender_state_name)="data">
					<b-badge
						class="text-nowrap"
						:variant="`light-${data.item.tender_state_color}`"
						pill
					>{{ data.item.tender_state_name }}</b-badge>
				</template>

				<template #cell(is_published)="data">
					<b-badge
						class="text-nowrap"
						:variant="`light-${ data.item.is_published ? 'success' : 'danger'}`"
						pill
					>{{ data.item.is_published ? 'PUBLICADO' : 'NO PUBLICADO' }}</b-badge>
				</template>

				<template #cell(published_at)="data">
					<div class="text-nowrap">{{ formatStringToDate(data.item.published_at) }}</div>
				</template>

				<template #cell(actions)="data">
					<b-dropdown
						v-if="$can('manage','tenders')"
						variant="link"
						no-caret
						:right="$store.state.appConfig.isRTL"
					>
						<template #button-content>
							<feather-icon
								icon="MoreVerticalIcon"
								size="16"
								class="align-middle text-body"
							/>
						</template>

						<b-dropdown-item :to="{ name: 'tenders-edit', params: { id: data.item.id } }">
							<feather-icon icon="EditIcon" />
							<span class="align-middle ml-50">Gestionar</span>
						</b-dropdown-item>

						<!-- <b-dropdown-item
							v-if="$can('manage','all') && [EN_CURSO, EN_REVISION, FINALIZADO].includes(data.item.tender_state_id)"
							:to="{ name: 'tenders-review', params: { id: data.item.id } }"
						>
							<feather-icon icon="CheckSquareIcon" />
							<span
								class="align-middle ml-50"
							>{{ data.item.tender_state_id === EN_REVISION ? 'Revisar' : 'Ver Revisión' }}</span>
						</b-dropdown-item>-->
					</b-dropdown>
					<div v-else>-</div>
				</template>
			</b-table>

			<div class="mx-2 mb-2">
				<b-row>
					<b-col
						cols="12"
						sm="6"
						class="d-flex align-items-center justify-content-center justify-content-sm-start"
					>
						<span
							class="text-muted"
						>Mostrando {{ dataMeta.from }} al {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
					</b-col>

					<b-col
						cols="12"
						sm="6"
						class="d-flex align-items-center justify-content-center justify-content-sm-end"
					>
						<b-pagination
							v-model="currentPage"
							:total-rows="totalTenders"
							:per-page="perPage"
							first-number
							last-number
							class="mb-0 mt-1 mt-sm-0"
							prev-class="prev-item"
							next-class="next-item"
						>
							<template #prev-text>
								<feather-icon
									icon="ChevronLeftIcon"
									size="18"
								/>
							</template>
							<template #next-text>
								<feather-icon
									icon="ChevronRightIcon"
									size="18"
								/>
							</template>
						</b-pagination>
					</b-col>
				</b-row>
			</div>
		</b-card>
	</div>
</template>

<script>
import { formatStringToDate } from "@core/utils/filter"
import { ref, onBeforeMount, onUnmounted } from "@vue/composition-api"
import { TenderStates } from "@core/utils/data"
import TendersListFilters from "./TendersListFilters.vue"
import tenderStoreModule from "../tenderStoreModule"
import { avatarText } from "@core/utils/filter"
import useNotifications from "@notifications"
import useTendersList from "./useTendersList"
import vSelect from "vue-select"
import store from "@/store"
import moment from "moment"
import axios from "@axios"

export default {
	components: {
		TendersListFilters,
		vSelect
	},
	data() {
		return {
			moment
		}
	},
	setup() {
		const { EN_CURSO, EN_REVISION, FINALIZADO } = TenderStates
		// USE TOAST
		const { toastNotification } = useNotifications()

		// REFS
		const options = ref({})

		const TENDER_APP_STORE_MODULE_NAME = "app-tender"

		// REGISTER MODULE
		if (!store.hasModule(TENDER_APP_STORE_MODULE_NAME))
			store.registerModule(TENDER_APP_STORE_MODULE_NAME, tenderStoreModule)

		// UNREGISTER ON LEAVE
		onUnmounted(() => {
			if (store.hasModule(TENDER_APP_STORE_MODULE_NAME))
				store.unregisterModule(TENDER_APP_STORE_MODULE_NAME)
		})

		// CALL FUNCTION TO POPULATE OPTIONS FOR THE FILTERS
		onBeforeMount(() => {
			getSelectFilters()
		})

		const getSelectFilters = async () => {
			try {
				const response = await axios.get("/selectors/tender-states")

				const publicStates = [
					{ label: "NO PUBLICADO", value: 0 },
					{ label: "PUBLICADO", value: 1 }
				]

				options.value = {
					publicStates,
					...response.data
				}
			} catch (error) {
				toastNotification(error.response.data.message, false)
			}
		}

		const {
			fetchTenders,
			tableColumns,
			perPage,
			currentPage,
			totalTenders,
			dataMeta,
			perPageOptions,
			searchQuery,
			sortBy,
			isSortDirDesc,
			refTenderListTable,
			refetchData,

			// EXTRA FILTERS
			publicStatesFilter,
			tenderStatesFilter
		} = useTendersList()

		return {
			fetchTenders,
			tableColumns,
			options,
			perPage,
			currentPage,
			totalTenders,
			dataMeta,
			perPageOptions,
			searchQuery,
			sortBy,
			isSortDirDesc,
			refTenderListTable,
			refetchData,
			EN_REVISION,
			FINALIZADO,
			EN_CURSO,

			// EXTRA FILTERS
			publicStatesFilter,
			tenderStatesFilter,

			// ACTIONS
			avatarText,
			formatStringToDate
		}
	}
}
</script>

<style lang="scss" scoped>
.media {
	align-items: center;
}

.per-page-selector {
	width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-sweetalert.scss";
</style>